import { render, staticRenderFns } from "./StudentWorksUpload.vue?vue&type=template&id=9a474a9c&scoped=true&"
import script from "./StudentWorksUpload.vue?vue&type=script&lang=js&"
export * from "./StudentWorksUpload.vue?vue&type=script&lang=js&"
import style0 from "./StudentWorksUpload.vue?vue&type=style&index=0&id=9a474a9c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a474a9c",
  null
  
)

export default component.exports